import { render, staticRenderFns } from "./recoverPassword2.vue?vue&type=template&id=4cd550d6&scoped=true"
import script from "./recoverPassword2.vue?vue&type=script&lang=js"
export * from "./recoverPassword2.vue?vue&type=script&lang=js"
import style0 from "./recoverPassword2.vue?vue&type=style&index=0&id=4cd550d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd550d6",
  null
  
)

export default component.exports